import protoRoot from "../proto-root";

const name = "deleteActivityLogEventRPCRequest";

function create(eventId) {
  const DeleteActivityLogEventRPCRequest = protoRoot.lookupType(
    "comm.DeleteActivityLogEventRPCRequest"
  );

  const request = DeleteActivityLogEventRPCRequest.create({
    eventId
  });
  return { payload: request, name };
}

export default {
  create,
  name
};

// message DeleteActivityLogEventRPCRequest {
//   int64 eventId = 1;
// }
